<ng-template #itemTemplate let-item>
    {{ item.contact.firstName }}
    <ng-container *ngIf="item.contact.lastName"> {{ item.contact.lastName }}</ng-container
    ><ng-container *ngIf="item.department"> - {{ item.department }}</ng-container>
    <ng-container *ngIf="props?.withMail && item.email"> - {{ item.email }}</ng-container>
</ng-template>
<ng-template #selectedItemTemplate let-item>
    {{ item.contact.firstName }}
    <ng-container *ngIf="item.contact.lastName"> {{ item.contact.lastName }}</ng-container>
    <ng-container *ngIf="props?.withMail && item.email"> - {{ item.email }}</ng-container>
</ng-template>

<ng-template #postSelectTemplate let-item>
    <i
        *ngIf="formControl?.value"
        class="grow-0 fa fa-info clickable flex items-center justify-center p-2 text-primary"
        (click)="showContact()"
        pTooltip="{{ 'crm.show-contact' | translate }}"
    ></i>
</ng-template>

<p-drawer [(visible)]="sidebarVisible" position="right" styleClass="!w-full md:!w-80 lg:!w-[40rem]">
    <ng-container *ngIf="sidebarVisible">
        <!-- <h4 class="!text-center mb-2">
            {{ 'crm.contact-details' | translate }}
            <a
                [href]="getContactEditLink(formControl.value?.contact)"
                class="fa fa-external-link-alt text-primary clickable"
            ></a>
        </h4> -->
        <app-contact-header-card-widget
            [detailModel]="formControl.value"
        ></app-contact-header-card-widget>
    </ng-container>

    <!-- below here we should show some info from the contact link and not just the contact-->
</p-drawer>
